import { getArray, getSubArray } from "../../../common";
import * as mappers from "../../mappers";
const mapEvent = (x) => mappers.mapEvent(x[1]);
const mapOffer = (x) => mappers.mapOffer(x[1]);
export function mapEventResponse(data) {
    const add = getSubArray(data, 0, 0);
    const eventsAdd = getArray(add, 0);
    const marketsAdd = getArray(add, 1);
    const remove = getSubArray(data, 0, 1);
    const eventsRemove = getArray(remove, 0);
    const marketsRemove = getArray(remove, 1);
    const change = getSubArray(data, 0, 2);
    const eventsChange = getArray(change, 0);
    const marketsChange = getArray(change, 1);
    const response = {
        data: {
            add: {
                events: eventsAdd.map(mapEvent),
                markets: marketsAdd.map(mapOffer),
            },
            change: {
                events: eventsChange.map(mapEvent),
                markets: marketsChange.map(mapOffer),
            },
            remove: {
                events: eventsRemove,
                markets: marketsRemove,
            },
        },
        metadata: data[2] || undefined
    };
    return response;
}
export function mapMarketsResponse(data) {
    const add = getSubArray(data, 0, 0);
    const remove = getSubArray(data, 0, 1);
    const change = getSubArray(data, 0, 2);
    const response = {
        data: {
            add: add.map(mapOffer),
            change: change.map(mapOffer),
            remove,
        },
        metadata: data[2] || undefined
    };
    return response;
}
//# sourceMappingURL=mapResponses.js.map